import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../../lib/supabase';
import './AccountSettings.css';

function ChangePhoneForm({ onClose, currentPhone }) {
  const { t } = useTranslation(['profile', 'shared']);
  const [newPhone, setNewPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    // Walidacja - podstawowa (opcjonalna)
    if (!newPhone.trim()) {
      setError(t('profile.settings.pages.account.changePhoneForm.errorEmpty'));
      return;
    }

    // Podstawowa walidacja formatu (opcjonalna)
    const phoneRegex = /^[\d\s\-+()]+$/;
    if (!phoneRegex.test(newPhone.trim())) {
      setError(t('profile.settings.pages.account.changePhoneForm.errorInvalid'));
      return;
    }

    if (newPhone.trim() === currentPhone) {
      setError(t('profile.settings.pages.account.changePhoneForm.errorSame'));
      return;
    }

    setLoading(true);

    try {
      // Aktualizacja numeru telefonu w Supabase Auth
      // Na razie bez weryfikacji SMS (TODO: dodać weryfikację SMS)
      const { error: updateError } = await supabase.auth.updateUser({
        phone: newPhone.trim()
      });

      if (updateError) {
        throw updateError;
      }

      setSuccess(true);
      
      // Odśwież dane użytkownika w tle (bez przeładowania strony)
      // Możemy odświeżyć dane przez ponowne pobranie z API, ale nie ma potrzeby reload całej strony
    } catch (err) {
      console.error('Error updating phone:', err);
      setError(err.message || t('profile.settings.pages.account.changePhoneForm.errorUpdate'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account-form-container">
      <h3 className="account-form-title">
        {t('profile.settings.pages.account.changePhoneForm.title')}
      </h3>

      <form onSubmit={handleSubmit} className="account-form">
        <div className="account-form-field">
          <label className="account-form-label">
            {t('profile.settings.pages.account.changePhoneForm.currentPhone')}
          </label>
          <div className="account-form-value">
            {currentPhone || t('profile.settings.pages.account.notSet')}
          </div>
        </div>

        <div className="account-form-field">
          <label htmlFor="newPhone" className="account-form-label">
            {t('profile.settings.pages.account.changePhoneForm.newPhone')}
            <span className="account-form-label-note">
              {' '}({t('profile.settings.pages.account.changePhoneForm.todoNote')})
            </span>
          </label>
          <input
            id="newPhone"
            type="tel"
            value={newPhone}
            onChange={(e) => setNewPhone(e.target.value)}
            placeholder={t('profile.settings.pages.account.changePhoneForm.newPhonePlaceholder')}
            className="account-form-input"
            disabled={loading || success}
            required
          />
        </div>

        {error && (
          <div className="account-form-error">
            {error}
          </div>
        )}

        {success && (
          <div className="account-form-success">
            {t('profile.settings.pages.account.changePhoneForm.success')}
          </div>
        )}

        <div className="account-form-info">
          {t('profile.settings.pages.account.changePhoneForm.info')}
        </div>

        <div className="account-form-actions">
          <button
            type="button"
            onClick={onClose}
            className="account-form-button account-form-button-secondary"
            disabled={loading}
          >
            {success ? t('common.close') : t('common.cancel')}
          </button>
          {!success && (
            <button
              type="submit"
              className="account-form-button account-form-button-primary"
              disabled={loading || !newPhone.trim()}
            >
              {loading
                ? t('profile.settings.pages.account.changePhoneForm.updating')
                : t('profile.settings.pages.account.changePhoneForm.updateButton')
              }
            </button>
          )}
        </div>
      </form>
    </div>
  );
}

export default ChangePhoneForm;

